import React, { useEffect, useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { HTTP_STATUSES } from "../../../../utils/consts";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import Notification from "../../../elements/notification/Notification";
import VerificationSchemaInfo from "./VerificationSchemaInfo";
import VerificationSchemaEdit from "./VerificationSchemaEdit";
import GoToBackButton from "../../../elements/goToBack/GoToBack";
import { useHistory } from "react-router-dom";

import { StyledContentWrapper } from "../../../styles/styledMain";
import { StyledVerificationSchemaDetailsWrapper } from "../../styledVerificationSchema";
import { StyledFormGrid } from "../../../styles/styledTabsForm";

const VerificationSchemaDetailsContainer = ({ match }) => {
  const history = useHistory();

  const [verificationSchema, setVerificationSchema] = useState(null);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchVerificationSchema = () => {
    axios.get("/api/project-verification-schemas/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setVerificationSchema(response.data);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  useEffect(() => {
    fetchVerificationSchema();
  }, []);

  if (!verificationSchema) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <StyledVerificationSchemaDetailsWrapper>
          <GoToBackButton
            handler={() => {history.goBack();}}
            pt="20"
            pb="30"
          />
          <StyledFormGrid>
            <VerificationSchemaInfo
              verificationSchema={verificationSchema}
            />
            <VerificationSchemaEdit
              verificationSchema={verificationSchema}
              setVerificationSchema={setVerificationSchema}
              notification={notification}
              setNotification={setNotification}
            />
          </StyledFormGrid>
        </StyledVerificationSchemaDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default VerificationSchemaDetailsContainer;